module.exports = __webpack_public_path__ + "media/images/default/lp_top_capture_file-eaa5e48eca1337f14f22cd45be8f7588.png";